module.exports = __webpack_public_path__ + "img/QQ.97962cf4.png";